<template>
    <img :src="qrcode" alt="qrcode_login">
</template>

<script>

import qrCode from 'qrcode'

export default {
    name: "QrCodeDesktop",
    props: {
        url: {type: String, required: true}
    },
    data: function() {
        return {qrcode: 'loading'}
    },
    created() {
      this.getQrCode();
    },
    watch: {
        qrcode: function(value) {
        },
        url: function(value) {
            qrCode.toDataURL(value, {errorCorrectionLevel: 'L', color: { light: "#FAFAFB"}}).then(url => {
                this.qrcode = url;
            });
        }
    },
    methods: {
        getQrCode() {
            qrCode.toDataURL(this.url).then(url => {
                this.qrcode = url
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/QrCodeDesktop.vue